import useAvailabilityStore from '~/stores/useAvailabilityStore';
import { useTraitAnalyticsData } from '@nuxt-common/media-card-large/app/composables/useTraitAnalyticsData';
import { computed } from 'vue';
import { useBrand } from '~/composables/useBrand';
import { useProductType } from '~/composables/useProductType';
import { useProductPrice } from '~/modules/price/composables/useProductPrice';
import { useProduct } from '~/modules/product/composables/useProduct';
import { useProtectionPlanAnalytics } from '~/modules/worry-no-more/analytics/useWnmAnalytics';
import useStickyAtbAnalytics from '~/modules/sticky-product-traits/composables/useStickyAtbAnalytics';

export default function tagColorChange() {
  const { productData: product } = useProduct();
  const { isConsolidatedMaster } = useProductType();
  const { isMcom } = useBrand();
  const { getExtraData } = useProtectionPlanAnalytics();
  const { extraTraitsData } = useStickyAtbAnalytics();

  const selectedPrice = useProductPrice();
  const availabilityData = computed(() => useAvailabilityStore().data);
  const productPricingState = computed(() => [String(selectedPrice.value?.priceTypeId || 'ZERO')]);

  const { fireTagOnChange } = useTraitAnalyticsData({
    isConsolidatedMaster,
    isMcom,
    product,
  });

  return {
    fireTag: () => {
      const selectedSddData = availabilityData.value?.upcNumberSddMap || {};

      setTimeout(() => {
        fireTagOnChange({
          isColorChage: true,
          productPricingState: productPricingState.value,
          selectedSddData,
          extraData: {
            ...getExtraData(),
            ...extraTraitsData('color'),
          },
        });
      }, 0);
    },
  };
}
